module.exports = __webpack_public_path__ + "media/mixkit-happy-bells-notification-937.6eac0ad3.mp3";